import React from 'react';
import api from '../api';
import config from '../config';

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.handleLogin = this.handleLogin.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.currentUser) {
      nextProps.router.push(config.FRONTEND_ADMIN_URL);
    }
  }
  render() {
    return (
      <div className="login-box">
        <div className="login-logo">
          <b>ADMIN</b>
        </div>
        <div className="login-box-body">
          <p className="login-box-msg">Login</p>
          <form role="form">
            <div className="form-group">
              <input ref="login" type="text" placeholder="Login" className="form-control" />
            </div>
            <div className="form-group">
              <input ref="password" type="password" placeholder="Password" className="form-control" />
            </div>
            <span className="text-red">{ this.props.error }</span>
            <div className="row">
              <div className="col-xs-8"></div>
              <div className="col-xs-4">
                <button className="btn btn-primary btn-block btn-flat" onClick={ this.handleLogin } disabled={ this.props.logging }>
                  Sign In
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
  handleLogin(event) {
    event.preventDefault();
    const login = this.refs.login.value;
    const password = this.refs.password.value;
    if (login && password) {
      const authUrl = config.BACKEND_ADMIN_URL + config.AUTH_URL;
      this.props.api.auth.login({ login, password, authUrl });
    }
  }
}

Login.propTypes = {
  api: React.PropTypes.object,
};

export default api.connect(Login, 'auth', { noClearOnUnmount: true });



// WEBPACK FOOTER //
// ./src/frontend/admin/authentication/Login.jsx